import withErrorGuard from 'components/core/withErrorGuard';
import Overlay from './Overlay';

export default withErrorGuard()(Overlay);
